import { BigNumber, ethers } from 'ethers';
import { PaymentCurrency_Enum } from './__generated__/graphql';
import type { BigNumberish } from 'ethers';

export enum Erc20DecimalEnum {
  'USDC' = 6,
  'ETH' = 18,
}

export const currencyMap: Record<PaymentCurrency_Enum, Erc20DecimalEnum> = {
  [PaymentCurrency_Enum.Eth]: Erc20DecimalEnum.ETH,
  [PaymentCurrency_Enum.Usdc]: Erc20DecimalEnum.USDC,
};

export const currencyConvert = (amount: string, currency?: string) => {
  return ethers.utils.formatUnits(
    BigNumber.from(String(amount)),
    currency ? Erc20DecimalEnum[currency as keyof typeof Erc20DecimalEnum] : 18
  );
};

export const addDecimals = (amount: number, currency?: Erc20DecimalEnum) => {
  // TODO: fix this to Bignumbers
  return (amount * Math.pow(10, currency ?? 6)).toString();
};

export const currency = (
  value: BigNumberish,
  currency?: PaymentCurrency_Enum
) => {
  if (!currency) {
    currency = PaymentCurrency_Enum.Usdc;
  }

  return (
    ethers.utils.commify(
      ethers.utils.formatUnits(value, currencyMap[currency])
    ) +
    ' ' +
    currency
  );
};
